import React, { useCallback, useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import { RelationshipContext } from '../relationshipUtils'
import RelationshipChangesRender from './RelationshipChangesRender'

// Reducer states
const finishedStatus = 'finishedStatus'

// Reduce actions
const startFetchAction = 'startFetchAction'

export default function RelationshipChanges() {
  usePageView({ page_detail: 'DMConsole:RelationshipChanges' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.relationship.changes'))

  const relationshipContext = useContext(RelationshipContext)
  const state = relationshipContext.state
  const dispatch = relationshipContext.dispatch
  let observer = null

  const getObserver = () => {
    if (observer === null) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio === 1) {
              // eslint-disable-next-line no-undef
              dispatch({ type: startFetchAction })
            }
          })
        },
        { threshold: 1 }
      )
    }
    return observer
  }

  const observerCallback = (node) => {
    if (node != null) {
      getObserver().observe(node)
    }
  }

  const observerBorder = useCallback(observerCallback, []) // eslint-disable-line react-hooks/exhaustive-deps

  const renderNoMoreChangesMessage = () => (
    <div>
      {t('changes.retrievedAll', 'Retrieved all changes:')} &nbsp; {state?.changes.length}
    </div>
  )
  const renderBottomBorder = () => <div ref={observerBorder} />

  return (
    <>
      {state?.changes && <RelationshipChangesRender changes={state.changes} idsMetadata={state.idsMetadata} />}
      {state?.status === finishedStatus && renderNoMoreChangesMessage()}
      {renderBottomBorder()}
    </>
  )
}
